import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Layout from "../components/Layout";
import { Signin, RedirectCallback, LogoutCallback } from "../Authentication/Callbacks";
import UnautherizeContent from "../components/UnautherizeContent";
import PrivateRoute from "../Shared/PrivateRoute";
import PageNotFound from "../components/PageNotFound";
import StaticDashboard from "../components/StaticDashboard";
import UserExist from "../components/UserExist";

function Routes() {
    return (
        <Router>
            <div>
                <Switch>
                    <Route exact={true} path="/" component={StaticDashboard} />
                    <Route exact={true} path="/login" component={Signin} />
                    <Route exact={true} path="/signin" component={RedirectCallback} />
                    <Route exact={true} path="/logout" component={LogoutCallback} />
                    <PrivateRoute path="/Home" component={Layout} />
                    <Route path="/pagenotfound" component={UnautherizeContent} />
                    <Route path="/usernotfound" component={UserExist} />
                    <Route path="*" component={PageNotFound} />
                </Switch>
            </div>
        </Router>
    );
}

export default Routes;
